import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Comment } from '../models/comment';
import { createCommentEndpoint } from './const';

export const createComment = (comment: Comment) => {
    return getHttpClient().post({ url: createCommentEndpoint, data: JSON.stringify(comment) });
};
